import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { authService } from '../services/AuthServices';
import './PageCss/AuthForm.css';
import { FaGoogle, FaGithub, FaEye, FaEyeSlash,FaFacebook } from 'react-icons/fa';
import { useLocation, useNavigate } from "react-router-dom";


const LoginPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    userName: '',
    password: '',
  });
const location = useLocation();
const navigate = useNavigate();

const from = location.state?.from || "/";

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.userName || !formData.password) {
      toast.error('Please fill in all fields');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await authService.login({
        userName: formData.userName,
        password: formData.password,
      });

      if (response.success) {
        toast.success('Login successful!');
       // const userRole = response.data.user.role;
          // return to previous page if exists
          if (from && from !== "/login" && from !== "/") {
            navigate(from, { replace: true });
          } else {
            navigate('/admin');
          }
      } else {
        toast.error(response.error || 'Login failed');
      }
    } catch (error) {
      toast.error('Failed to connect to server');
    } finally {
      setIsSubmitting(false);
    }
  };
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
    <div className="auth-container">
      <div className="login-card">
        <div className="auth-header">
          <h1 className="login-title">Welcome Back</h1>
          <p className="auth-subtitle">Sign in to continue</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-input-group">
            <input
              type="text"
              className="login-input"
              placeholder="Username"
              value={formData.userName}
              onChange={(e) => setFormData({...formData, userName: e.target.value})}
              required
            />
          </div>

          <div className="auth-input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="login-input"
              placeholder="Password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              required
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button
              type="submit"
              className="login-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Logging in...' : 'Login'}
            </button>
        </form>

        <div className="auth-divider">
          <span>or continue with</span>
        </div>

        <div className="social-buttons">
          <button className="social-btn">
            <FaGoogle />
          </button>
          <button className="social-btn">
            <FaGithub />
          </button>
          <button className="social-btn">
            <FaFacebook />
          </button>
        </div>

        <div className="auth-footer">
          Don't have an account? <a href="/signup" className="auth-link">Sign up</a>
        </div>
      </div>
    </div>
    <ToastContainer 
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
</>
  );
};

export default LoginPage;